// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"162":"b01cbe87","317":"b01cbe87","844":"11a4ef7f","983":"b01cbe87"}[chunkId] + ".css";
};